export default {
  baseStyle: {
    control: {
      borderColor: 'greys.200',
    },
  },
  defaultProps: {
    colorScheme: 'primary',
  },
}
